/**
 * directive to show a gallery of images
 */
angular.module('impactx.product').directive('ixGallery', function () {
    return {
        scope: {},
        bindToController: {
            mainImage: '=',
            allImages: '=',
            product: "=?",
            imageClass: '=?'
        },
        restrict: 'E',
        controller: "GalleryCtrl",
        controllerAs: "galleryCtrl",
        templateUrl: 'shared/displayelements/templates/gallery.html',
        transclude: true
    };
});